import axios from 'axios';

class ChainsCategoriesService {
	getChainsMenuCategories() {
		return axios.get('Home/GetChainsMenuCategories');
	}
}

export default new ChainsCategoriesService();
